<template>
  <div class="card audio-player">
    <div class="row">
      <span>播放文件名：</span>
      <!-- 文件选择列表 -->
      <select v-model="currentFile" @change="resetPlayer" class="file-select">
        <option v-for="(file, index) in fileList" :key="index" :value="file">{{ file }}</option>
      </select>
    </div>

    <div class="row controls-row">
      <button class="btn btn-primary" @click="playWebAudio(deviceId,currentFile),playWeb">
      {{ '网页播放' }}
    </button>

    <!-- 终端播放按钮 -->
    <button class="btn btn-primary" @click="playDevice">
      {{ '终端播放' }}
    </button>

    </div>

    <div class="row">
      <span>播放进度条：</span>
      <audio style="margin-left:10px" :src="audioSource"  controls autoplay>
    </audio>
    </div>
    
    <div class="progress-bar">
      <div class="progress-inner" :style="{ width: progress + '%' }"></div>
    </div>
  </div>
</template>

<script>
import { playMusic} from '@/api/api'
export default {
  name: 'AudioPlayer',
  props: {
    // 接收父组件传递的设备 ID
    fileList: {
      type: Array,
      required: true
    },
     deviceId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // 文件列表，用户可以选择其中一个播放
      currentFile: '',
      isPlaying: false,
      progress: 0,
      timer: null,
      audioSource: null,  // 用来存储音频源 URL
    }
  },
    watch: {
    // 监听 fileList 的变化
    fileList(newFileList) {
      if (newFileList && newFileList.length > 0) {
        this.currentFile = newFileList[0];  // 设置 currentFile 为 fileList 的第一个文件
      }
    }
  },
   mounted() {
    // 调用封装的音频播放方法
   
  },
  methods: {
     playWeb() {
      this.$emit('playWeb');
    },
    // 点击终端播放按钮，通知父组件执行方法
    playDevice() {
      
      if(this.currentFile){
        
this.$emit('handleDevicePlay', this.currentFile);
      }
      
    },



  playWebAudio(deviceId, fileName) {
      if(!fileName){
        return
      }

      playMusic(deviceId, fileName)
        .then(response => {
          // 假设后端返回的是音频文件的二进制流，使用 URL.createObjectURL 来创建播放的 URL
           if (response && response instanceof Blob) {
            // 使用 URL.createObjectURL 创建音频文件 URL
            this.audioSource = URL.createObjectURL(response);
           
          } else {
            
            console.error('返回的数据不是 Blob 类型');
            this.audioSource = null;
          }
        })
        .catch(error => {
         if (error.response && error.response.status === 404) {
      // 如果返回 404 错误，执行特定的逻辑
      console.error("文件未找到 (404):", error);
      this.audioSource = null;
      this.$emit('fileNotFound', fileName);
      
    } else {
      // 处理其他类型的错误
      console.error("Error fetching audio file:", error);
      this.audioSource = null; // 错误处理
    }
          this.audioSource = null; // 错误处理
        });
    },
  

    togglePlay() {
      this.isPlaying = !this.isPlaying
      if (this.isPlaying) {
        this.startMockProgress()
      } else {
        clearInterval(this.timer)
      }
    },
    startMockProgress() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.progress >= 100) {
          this.progress = 0
          this.isPlaying = false
          clearInterval(this.timer)
        } else {
          this.progress += 2
        }
      }, 300)
    },
    // 切换文件时重置播放器状态
    resetPlayer() {
      this.progress = 0
      this.isPlaying = false
      clearInterval(this.timer)
    },
   
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>
.row {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 6px;
  color: #e5e7eb;
}

.row:first-child {
  margin-top: 0;
}

.controls-row {
  margin: 25px 0px;
  gap: 10px;
  flex-wrap: wrap;
}

.file-name {
  margin-left: 4px;
}

.file-select {
  margin-left: 10px;
  padding: 5px;
  font-size: 14px;
  border: 1px solid #4b5563;
  /* background-color: #2b2b2b; */
  color: #e5e7eb;
}

@media (max-width: 600px) {
  .controls-row .btn {
    flex: 1;
  }
}
</style>
